import React, { Component } from 'react';
import {connect} from 'react-redux';
import * as actionCreators from '../../store/actionCreators';
import * as actionTypes from "../../store/actions";
import AdvisorAuth from "../../services/AdvisorAuth";

class Start extends Component {

    componentWillReceiveProps(nextProps) {
        if (!nextProps.isAuthorized) return;

        if (this.props.byPassIntroduction) {
            this.props.setCompanyName();
            this.props.history.push("/introduction");
            // this.props.history.push("/annuityCalculator");
        } else {
            this.props.history.push("/introduction");
        }
    }


    componentDidMount() {
        if (!this.props.isAuthorized) {
            let qstring = this.props.location.search;
            let pair = qstring.split("=");
            let token = pair[1];

            this.props.login(token);
            AdvisorAuth.setInstitute("WELLS_FARGO");
        }
    }

    render() {
        return (
            <div>
                You are not authorized to view this page.
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthorized: state.globalState.isAuthorized,
        byPassIntroduction: state.globalState.byPassIntroduction
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        login: (token) => dispatch(actionCreators.getTokenAndLogin(token)),
        setCompanyName: () => dispatch({
            type: actionTypes.SET_COMPANY_NAME,
            value: "WELLS_FARGO"
        })
    }
};

export default connect(mapStateToProps, mapDispatchToProps) (Start);


// WEBPACK FOOTER //
// ./src/containers/Start/start.js